/**
 * useReportSummaries - React Query hook for batch report summaries
 *
 * Fetches report summary metrics for all clients for a given month.
 * Used by the clients dashboard to show reporting status inline.
 */

import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/services/apiClient";
import type { ReportSummaryMap } from "@/types";

const reportSummaryKeys = {
  all: (year: number, month: number) =>
    ["report-summaries", year, month] as const,
};

export function useAllReportSummaries(year: number, month: number) {
  return useQuery({
    queryKey: reportSummaryKeys.all(year, month),
    queryFn: async (): Promise<ReportSummaryMap> => {
      const response = await apiClient.get<ReportSummaryMap>(
        "/api/social-media/report-summaries",
        { params: { year, month } }
      );
      return response;
    },
    staleTime: 5 * 60 * 1000,
  });
}
